/// <reference path="../typings/tsd.d.ts"/>
console.log('App Ver:', '__GIT_MY_VERSION__');
require('@babel/polyfill');
require('./components/application');
